import { createElement, useRef, useEffect } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Button from '@hfe/max-button';
import LImage from '@max/leez-image';
import { Animated } from '@max/mbc-animated';
import AnimatedView from '@max/mbc-animate-view';
import './index.scss';
import Sensor from '@max/mbc-sensor';
import { remUnit, toPx } from '@max/leez-style-util';
const FixedBar = (props) => {
    const { remainDrawTimes, isOrderExist, onGoAnchor, onClose, autoCloseDelay = 3000, onAppear, marginTop = 0 } = props;
    const translateY = useRef(new Animated.Value(-104)).current;
    const opacity = useRef(new Animated.Value(0)).current;
    const timerRef = useRef(null);
    console.log('dddd', remUnit(marginTop), toPx(marginTop));
    useEffect(() => {
        // 组件挂载时执行显示动画
        Animated.parallel([Animated.timing(translateY, {
                toValue: 0,
                duration: 500,
                easing: Animated.Easing.bezier(0.25, 0.1, 0.25, 1.0),
                useNativeDriver: true
            }), Animated.timing(opacity, {
                toValue: 1,
                duration: 500,
                easing: Animated.Easing.bezier(0.25, 0.1, 0.25, 1.0),
                useNativeDriver: true
            })]).start();
        // 设置定时器，5秒后自动关闭
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            handleClose();
        }, autoCloseDelay);
        // 组件卸载时清除定时器
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [autoCloseDelay]);
    const handleClose = () => {
        // 清除定时器
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        // 执行关闭动画
        Animated.parallel([Animated.timing(translateY, {
                toValue: -104,
                duration: 500,
                easing: Animated.Easing.bezier(0.25, 0.1, 0.25, 1.0),
                useNativeDriver: true
            }), Animated.timing(opacity, {
                toValue: 0,
                duration: 500,
                easing: Animated.Easing.bezier(0.25, 0.1, 0.25, 1.0),
                useNativeDriver: true
            })]).start(() => {
            onClose();
        });
    };
    return <Sensor onAppear={onAppear} style={{
        height: '104rpx',
        overflow: 'hidden',
        marginTop: remUnit(marginTop)
    }}>
      <AnimatedView viewId="fixed-bar-container" style={{
        height: '104rpx'
    }} animateStyles={{
        transform: [{
                translateY: translateY
            }],
        opacity: opacity
    }}>
        <View className="top-fix-bar">
          <LImage source={{
        uri: 'https://p0.meituan.net/ingee/bb536b692fa729e576ed7a4e783a6e9c1157.png'
    }} style={{
        width: '43rpx',
        height: '43rpx',
        marginLeft: '36rpx'
    }} borderRadius={0}/>
          <Text className="top-fix-bar-text" numberOfLines={2}>
            你的好友为你打Call成功啦！你获得了<Text style={{
        color: '#FBFF0F'
    }}> {remainDrawTimes} </Text>次抽免单机会
          </Text>
          <Button className="top-fix-bar-anchor" onPress={onGoAnchor}>
            <Text className="top-fix-bar-anchor-text">{isOrderExist ? '去抽免单' : '下单赢免单'}</Text>
          </Button>
          <Button className="top-fix-bar-anchor-close" onPress={handleClose}>
            <LImage source={{
        uri: 'https://p0.meituan.net/ingee/b131ba4c85c7869e9ea2eca00e098ef2359.png'
    }} style={{
        width: '48rpx',
        height: '48rpx'
    }}/>
          </Button>
        </View>
      </AnimatedView>
    </Sensor>;
};
export default FixedBar;
